import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useConfirmDelete } from '@/components/ConfirmDialogs';
import { fmtStamp } from '@/utils/dateFmt';

/* Modal reutilizável para mostrar o histórico de versões de um campo de texto clínico
   (Notas de consulta, Objetivos, Observações, Resumo da Reunião, Observações da ficha).
   `history`: lista de { text, replaced_by_name, replaced_at }, mais recente primeiro.
   `onRestore(text)`: aplica a versão escolhida ao formulário atual (ainda precisa de Guardar). */
export function FieldVersionHistoryModal({ open, onOpenChange, fieldLabel, history, onRestore }) {
  const confirmDelete = useConfirmDelete();
  const ordered = [...(history || [])].reverse();

  const handleRestore = async (entry) => {
    const ok = await confirmDelete({
      description: `Vais repor esta versão anterior de ${fieldLabel}. O texto atual é substituído (podes voltar a guardar depois).`,
      confirmLabel: 'Repor esta versão',
    });
    if (!ok) return;
    onRestore(entry.text);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl border-brand-border max-w-md" data-testid="field-version-history-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-brand-text">Versões anteriores de {fieldLabel}</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {ordered.length === 0 && <p className="text-sm text-brand-muted">Ainda não há versões anteriores guardadas.</p>}
          {ordered.map((entry, i) => (
            <div key={i} className="bg-brand-bg/50 rounded-xl p-3" data-testid={`version-history-entry-${i}`}>
              <p className="text-xs text-brand-muted mb-1">
                {entry.replaced_by_name ? `${entry.replaced_by_name} · ` : ''}
                {entry.replaced_at ? fmtStamp(entry.replaced_at) : ''}
              </p>
              <p className="text-sm text-brand-text whitespace-pre-line line-clamp-6">{entry.text}</p>
              <button
                type="button"
                onClick={() => handleRestore(entry)}
                className="mt-2 text-xs text-brand-green font-medium hover:underline"
                data-testid={`restore-version-btn-${i}`}
              >
                Repor esta versão
              </button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
